// Map an API product doc (or a mock product) to the shape the customer
// storefront needs. The admin product model uses: productName, retailPrice,
// description, category/categoryId, brand/brandId, images:[{url,...}], sku,
// barcode, trackStock, sellOnline, quantity/inStock.

// Gradient placeholders so a product with no photo still looks intentional
// (the storefront should never show a broken image).
const PLACEHOLDER_GRADIENTS = [
  'linear-gradient(135deg, #E8EDF2 0%, #D7DEE6 100%)',
  'linear-gradient(135deg, #F2ECE4 0%, #E6DACB 100%)',
  'linear-gradient(135deg, #E4EEF0 0%, #CFE3E6 100%)',
  'linear-gradient(135deg, #EDE8F0 0%, #DCD3E6 100%)',
];
export const placeholderFor = (seed = 0) => PLACEHOLDER_GRADIENTS[Math.abs(seed) % PLACEHOLDER_GRADIENTS.length];

const nameOf = (val, key) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  return val[key] || val.name || '';
};

const imagesOf = (p) => {
  const arr = p.images || p.photos || [];
  const urls = (Array.isArray(arr) ? arr : [])
    .map((im) => (typeof im === 'string' ? im : (im && (im.url || im.src || im.image))))
    .filter(Boolean);
  if (urls.length) return urls;
  if (p.image) return [p.image];
  return []; // empty → the card/detail renders a gradient placeholder
};

export const mapProduct = (p, i = 0) => {
  const id = p.id || p._id || `p-${i}`;
  return {
    id,
    name: p.name || p.productName || 'Product',
    price: Number(p.price != null ? p.price : p.retailPrice) || 0,
    // Retail variants (Colour/Size...): [{_id, optionValues, retailPrice, inStock, image}]
    options: Array.isArray(p.options) ? p.options : [],
    variants: Array.isArray(p.variants) ? p.variants.map((v) => ({
      id: v._id || v.id,
      optionValues: v.optionValues || {},
      price: Number(v.retailPrice != null ? v.retailPrice : (p.price != null ? p.price : p.retailPrice)) || 0,
      inStock: v.inStock !== false,
      image: v.image || '',
    })) : [],
    description: p.description || '',
    images: imagesOf(p),
    category: nameOf(p.category, 'categoryName') || 'Other',
    brand: nameOf(p.brand, 'brandName') || '',
    sku: p.sku || '',
    // trackStock off → treat as always available; else use quantity/inStock.
    inStock: p.trackStock === 0 || p.trackStock === false
      ? true
      : (p.inStock != null ? !!p.inStock : (p.quantity != null ? Number(p.quantity) > 0 : true)),
    sellOnline: p.sellOnline == null ? 1 : (p.sellOnline ? 1 : 0),
    // grams — feeds weight-based shipping rates at checkout (0 = unweighted).
    weight: Number(p.weight) || 0,
  };
};

export const mapProducts = (list) => (Array.isArray(list) ? list.map(mapProduct) : []);
